import React, { Fragment } from "react";
import Avatar from "@mui/joy/Avatar";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import ListDivider from "@mui/joy/ListDivider";
import Select, { SelectOption } from "@mui/joy/Select";
import Option from "@mui/joy/Option";
import en_flag from "../assets/lang/en.png";
import kor_flag from "../assets/lang/kor.png";
import uzb_flag from "../assets/lang/uzb.png";
import vet_flag from "../assets/lang/vet.png";
import thai_flag from "../assets/lang/thai.png";
import bang_flag from "../assets/lang/bangladesh.png";
import nepal_flag from "../assets/lang/nepal.png";
import si_flag from "../assets/lang/si.png";

// Define the type for the props
type TranslateComponentProps = {
  handleChangeLanguage: (lang: string, label: string) => void;
  value: string;
};

const options = [
  { value: "en", label: "English", src: `${en_flag}` },
  { value: "kor", label: "Korean", src: `${kor_flag}` },
  { value: "uzb", label: "Uzbek", src: `${uzb_flag}` },
  { value: "vet", label: "Vietnamese", src: `${vet_flag}` },
  { value: "thai", label: "Thai", src: `${thai_flag}` },
  { value: "bn", label: "Bengali", src: `${bang_flag}` },
  { value: "ne", label: "Nepali", src: `${nepal_flag}` },
  { value: "si", label: "Sinhala", src: `${si_flag}` },
];

function renderValue(option: SelectOption<string> | null) {
  if (!option) {
    return null;
  }

  return (
    <Fragment>
      <ListItemDecorator>
        <Avatar
          size="sm"
          src={options.find((o) => o.value === option.value)?.src}
        />
      </ListItemDecorator>
      {option.label}
    </Fragment>
  );
}

export default function TranslateComponent({
  handleChangeLanguage,
  value,
}: TranslateComponentProps) {
  const handleSelectChange = (
    _event: React.SyntheticEvent | null,
    newValue: string | null
  ) => {
    if (!newValue) return;
    const opt = options.find((o) => o.value === newValue);
    if (opt) {
      handleChangeLanguage(opt.value, opt.label);
    }
  };

  return (
    <Select
      value={value}
      onChange={handleSelectChange}
      slotProps={{
        listbox: {
          sx: {
            "--ListItemDecorator-size": "44px",
          },
        },
      }}
      sx={{
        "--ListItemDecorator-size": "44px",
        minWidth: 240,
      }}
      renderValue={renderValue}
    >
      {options.map((option, index) => (
        <Fragment key={option.value}>
          {index !== 0 ? (
            <ListDivider role="none" inset="startContent" />
          ) : null}
          <Option value={option.value} label={option.label}>
            <ListItemDecorator>
              <Avatar size="sm" src={option.src} />
            </ListItemDecorator>
            {option.label}
          </Option>
        </Fragment>
      ))}
    </Select>
  );
}
